import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { MessagesService } from 'src/app/services/messages.service';
import { SharedService } from 'src/app/services/shared.service';
import { NavigationService } from 'src/app/services/navigation.service'; 

@Component({
  selector: 'app-areas-d',
  templateUrl: './areas-d.component.html',
  styleUrls: ['./areas-d.component.css']
})
export class AreasDComponent {

  area = {
    clave: '',
    nombre: ''
  }

  opE: any;
  token: any;
  retrievedArea: any;
  rol: any;

  // declaración de los mensajes de validación 
  showErrorMessageAcronimo : boolean = false;
  showErrorMessageNombre   : boolean = false;
  mensajeValidacionAcronimo: string  = '';
  mensajeValidacionNombre  : string  = '';
  mensaje                  : string  = 'Campo requerido.';

  iconoMostrar: string = '';
  nameBoton: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private requestsService: CatalogsService,
    private messagesService: MessagesService,
    private navigationService: NavigationService) { }

  ngOnInit() {
    this.verificacionUsuario();  
    this.obtnerIcono();
  }

  obtnerIcono(){
    this.iconoMostrar = this.opE === '1' ? 'bi-arrow-left-circle' : 'bi-x-circle';
    this.nameBoton = this.opE === '1' ? 'Regresar' : 'Cancelar';
  }

  verificacionUsuario(){
    this.rol = localStorage.getItem('rol');
    this.token = String(localStorage.getItem('token1'));
    this.navigationService.disableNavigation();
    this.opE = this.route.snapshot.paramMap.get('datos');
    if (this.opE === '1') {//obtendgo creditor para actualizar
      this.retrievedArea = this.sharedService.getDataArray();
      this.cargarArea(this.retrievedArea);
    }
  }

  async cargarArea(getarea: any) {
    this.area.nombre = getarea.Dir_Nombre
    this.area.clave = getarea.Dir_Clave
  }

  async validaFormulario(guardar: any, editar: any) {
    if ( this.area.nombre === '' || this.area.clave === '') {
      this.messagesService.showError('Todos los campos son obligatorios');
      return;
    }
    if (guardar === true) {
      this.guardar()
    }
    if (editar === true) {
      this.editar()
    }
  }

  editar() {
    this.requestsService.editArea(this.area, this.retrievedArea.Id_Direccion, this.token).subscribe(
      (res) => {
        this.navegarMensaje(res.message);
      },(err) => {
        this.messagesService.showError(err.error.error[0].message);
      }
    )
  }

  guardar() {
    this.requestsService.createArea(this.area, this.token).subscribe(
      (res) => {
        this.navegarMensaje(res.message);
      },(err) => {
        this.messagesService.showError(err.error.message);
      }
    )
  }

  eliminar() {
    this.requestsService.deleteArea(this.retrievedArea.Id_Direccion, this.token).subscribe(
      (res) => {
        this.navegarMensaje(res.message);
      },(err) => {
        this.messagesService.showError(err.error.error[0].message);
      }
    )
  }

  navegarMensaje(res: any){
    this.messagesService.showMessage(res);
    this.cancelar();
  }

  cancelar() {
    this.router.navigate(['/areas']);
  }

  private isNumber(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }

  private isValidEmail(email: string): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }

  // mensajes de validación 
  mostrarMensaje(campo: any, tipo: string) {
    if (tipo === 'acronimo') {
      if (campo.invalid && (campo.dirty || campo.touched)) {
        this.showErrorMessageAcronimo = true;
        this.mensajeValidacionAcronimo = this.mensaje;
      } else {
        this.showErrorMessageAcronimo = false;
      }
    } else if (tipo === 'nombre') {
      if (campo.invalid && (campo.dirty || campo.touched)) {
        this.showErrorMessageNombre = true;
        this.mensajeValidacionNombre = this.mensaje;
      } else {
        this.showErrorMessageNombre = false;
      }
    }
  }
}